import { TableCell, TableRow, Typography } from '@mui/material';
import React, { FC, memo } from 'react';
import { useForceUpdateTableItem } from '../../../presenters/useSubscriptionsTableItem';
import { IPlatform } from '../../../entity/platforms/IPlatform';
import { TextInput } from 'src/UIKit/TextInput';
import { styles } from './styles';

interface IProps {
    item: IPlatform;
};

export const PlatformTableRow: FC<IProps> = memo(({ item }) => {
    const { onChangeMininalVersion, onChangeRecommendedVersion, platform, handleBlur, onChangeLink } = useForceUpdateTableItem(item);

    return (
        <TableRow hover >
            <TableCell align='left' width='20%'>
                <Typography variant="subtitle2" ml={3} sx={styles.text}>{item.name}</Typography>
            </TableCell>
            <TableCell align={'center'} width='20%'>
                <TextInput name='minimal_version' onChange={onChangeMininalVersion} value={platform.minimal_version} onBlur={handleBlur} />
            </TableCell>
            <TableCell align={'center'} width='20%'>
                <TextInput name='recommended_version' onChange={onChangeRecommendedVersion} value={platform.recommended_version} onBlur={handleBlur} />
            </TableCell>
            <TableCell align={'center'} width='40%'>
                <TextInput name='link' onChange={onChangeLink} value={platform.link} onBlur={handleBlur} />
            </TableCell>
        </TableRow>
    );
})
